module.exports = __webpack_public_path__ + "src/img/notifyClose.962fb25c.svg";